/**
 * Filter table rows by a search string across the given field keys (case-insensitive).
 */
export function filterRowsByQuery(rows, query, fieldKeys) {
  const q = String(query ?? "").trim().toLowerCase();
  if (!q) return rows;
  return rows.filter((item) =>
    fieldKeys.some((key) =>
      String(item[key] ?? "").toLowerCase().includes(q)
    )
  );
}
